"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerWaysteUsageEventQuery = exports.HaulerWaysteUsageEvent = exports.HaulerWaysteUsageEventDetails = exports.HaulerWaysteCheckoutType = exports.HaulerWaysteUsageEventType = exports.HaulerWaysteCheckoutTypes = exports.HaulerWaysteUsageEventTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.HaulerWaysteUsageEventTypes = ['LOGIN', 'DRIVER_SCHEDULING', 'CHECKOUT'];
exports.HaulerWaysteCheckoutTypes = ['INVOICE_PAYMENT', 'WAYSTE_UI', 'WHITE_LABEL'];
exports.HaulerWaysteUsageEventType = typebox_1.Type.Union(exports.HaulerWaysteUsageEventTypes.map((value) => typebox_1.Type.Literal(value)));
exports.HaulerWaysteCheckoutType = typebox_1.Type.Union(exports.HaulerWaysteCheckoutTypes.map((value) => typebox_1.Type.Literal(value)));
exports.HaulerWaysteUsageEventDetails = typebox_1.Type.Object({
    // All properties are optional to facilitate adding new ones without  breaking existing
    // records. The intended usage of the events table is strictly append-only, so backfilling
    // is not an option.
    // common
    actingUserID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // login
    // no additional fields needed
    // driver-scheduling
    driverID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // checkout
    stripePaymentID: typebox_1.Type.Optional(typebox_1.Type.String()),
    amount: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    checkoutType: typebox_1.Type.Optional(exports.HaulerWaysteCheckoutType),
});
exports.HaulerWaysteUsageEvent = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    timestamp: typebox_1.Type.String({ format: 'date-time' }),
    usageType: exports.HaulerWaysteUsageEventType,
    usageEventDetails: exports.HaulerWaysteUsageEventDetails,
});
exports.HaulerWaysteUsageEventQuery = typebox_1.Type.Object({
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    /* limit: Type.Optional(Type.Integer({ minimum: 1, maximum: 100 })),
    offset: Type.Optional(Type.Integer({ minimum: 0 })),
    orderBy: Type.Optional(Type.String()),
    reverseSort: Type.Optional(Type.Boolean()), */
});
//# sourceMappingURL=hauler-wayste-usage-event.js.map